"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getResourceState = exports.getDetail = exports.getList = exports.initialResourceState = exports.initialState = void 0;
var initialState = {};
exports.initialState = initialState;
var initialResourceState = {
  list: [],
  detail: null
};
exports.initialResourceState = initialResourceState;

var getResourceState = function (state, resource) {
  if (state === void 0) {
    state = initialState;
  }

  return state[resource] || initialResourceState;
};

exports.getResourceState = getResourceState;

var getDetail = function (state, resource) {
  if (state === void 0) {
    state = initialState;
  }

  return getResourceState(state, resource).detail;
};

exports.getDetail = getDetail;

var getList = function (state, resource) {
  if (state === void 0) {
    state = initialState;
  }

  return getResourceState(state, resource).list;
};

exports.getList = getList;